import axios from 'axios';
import getBaseUrl from '../../../shared/utils/Host';

const BaseUrl = getBaseUrl();
const API_URL = `${BaseUrl}order`;

export const createOrder = (product) => {
    const token = localStorage.getItem('token');

    return axios.post(API_URL, product, {
    headers: {
        Authorization: `Bearer ${token}`, // Send token in Authorization header
    },
});}